import React from 'react';


const Treatment = () => {
  const services = [
    "Party Peeling for Instant Glow",
    "Chemical Peeling",
    "Electro Cautery",
    "Radio Cautery",
    "Mole Removing",
    "Skin Tag Removing",
    "Vitiligo Surgery",
    "PUVA Therapy",
    "PRP (Platelet Rich Plasma)",
    "Skin Rejuvenation",
    "Open Pores Treatment",
    "Laser Hair Removal",
    "Hydra Facial",
    "Scar Treatment",
    "Keloid Treatment"
  ];

  return (
    <div className="treatment-section">
      <h2>Our Treatments</h2>
      <div className="services-container">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <h3>{service}</h3>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Treatment;
